<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex md5>
        <v-card class="h-100">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <span clas="subheading">
                  Todas las agencias
                </span>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex md6>
                    <v-flex class="headline" xs12>
                      <v-icon class="black-icon">
                        fas fa-users
                      </v-icon>
                      {{ allAgencies.conected }}
                    </v-flex>
                    <span class="custom-caption">
                      Agentes conectados
                    </span>
                  </v-flex>
                  <v-flex md6>
                    <v-flex class="headline" xs12>
                      {{ allAgencies.unanswered }}
                    </v-flex>
                    <span class="custom-caption">
                      Por responder
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex md6>
                    <v-flex class="headline" xs12>
                      {{ allAgencies.waiting }}
                    </v-flex>
                    <span class="custom-caption">
                      En espera
                    </span>
                  </v-flex>
                  <v-flex md6>
                    <v-flex class="headline" xs12>
                      <v-icon class="black-icon">
                        fas fa-hourglass-half
                      </v-icon>
                      {{ toHuman(allAgencies.waitingTime) }}
                    </v-flex>
                    <span class="custom-caption">
                      Tiempo de espera
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md7>
        <v-card class="h-100">
          <v-card-text>
            <vue-perfect-scrollbar :settings="options">
              <div class="scrollBar">
                <v-layout row pa-3 wrap>
                  <template v-for="(agency, i) in agencies">
                    <v-flex :class="{'mt-3': i > 0}" :key="`agency-${i}`" class="borders" xs12>
                      <v-layout row wrap>
                        <v-flex xs12 pb-0>
                          <span class="headline">
                            Rexa
                          </span>
                        </v-flex>
                        <v-flex class=" smallest " md3 pt-0>
                          <v-flex class="headline" xs12>
                            <v-icon class="black-icon">
                              fas fa-users
                            </v-icon>
                            {{ agency.conected }}
                          </v-flex>
                          <span class="custom-caption">
                            Agentes conectados
                          </span>
                        </v-flex>
                        <v-flex class=" smallest text-xs-center" md3 pt-0>
                          <v-flex class="headline" xs12>
                            {{ agency.unanswered }}
                          </v-flex>
                          <span class="custom-caption">
                            Por responder
                          </span>
                        </v-flex>
                        <v-flex class=" smallest text-xs-center" md3 pt-0>
                          <v-flex class="headline" xs12>
                            {{ agency.waiting }}
                          </v-flex>
                          <span class="custom-caption">
                            En espera
                          </span>
                        </v-flex>
                        <v-flex class=" smallest " md3 pt-0>
                          <v-flex class="headline" xs12>
                            <v-icon class="black-icon">
                              fas fa-hourglass-half
                            </v-icon>
                            {{ toHuman(agency.waitingTime) }}
                          </v-flex>
                          <span class="custom-caption">
                            Tiempo de espera
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </template>
                </v-layout>
              </div>
            </vue-perfect-scrollbar>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import moment from 'moment';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScrollbar,
  },
  created() {
    moment.locale('es', {
      relativeTime: {
        future: 'en %d s',
        past: 'hace %d s',
        s: '%d s',
        m: '%d m',
        mm: '%d m',
        h: '%d h',
        hh: '%d h',
        d: '%d d',
        dd: '%d d',
        M: '%d M',
        MM: '%d M',
        y: '%d a',
        yy: '%d a',
      },
    });
  },
  data() {
    return {
      agencies: [
        {
          title: 'Rexa',
          conected: 12,
          unanswered: 239,
          waiting: 156,
          waitingTime: 600,
        },
        {
          title: 'Plus consulting',
          conected: 12,
          unanswered: 239,
          waiting: 156,
          waitingTime: 590,
        },
      ],
      options: {
        suppressScrollX: true,
      },
    };
  },
  computed: {
    allAgencies() {
      const allAgencies = {
        conected: 0,
        unanswered: 0,
        waiting: 0,
        waitingTime: 0,
      };
      for (let i = 0; i < this.agencies.length; i += 1) {
        allAgencies.conected += Number(this.agencies[i].conected);
        allAgencies.unanswered += Number(this.agencies[i].unanswered);
        allAgencies.waiting += Number(this.agencies[i].waiting);
        allAgencies.waitingTime += Number(this.agencies[i].waitingTime);
      }
      return allAgencies;
    },
  },
  methods: {
    toHuman(time) {
      return moment.duration(time, 'seconds').humanize();
    },
  },
};
</script>
<style scoped>
.custom-caption {
  font-size: 11px;
}
.smallest {
  font-size: 11px;
}
.black-icon {
  color: #000;
}
.scrollBar {
  height: 36vh;
}
.borders {
  border: 1px solid #d3d3d3;
}
.list-titlte, .list-content {
  height: auto;
}
.scrollBar > .layout {
  width: 40vw;
}
</style>




// WEBPACK FOOTER //
// src/components/chat_center_v2/dashboard/Agencies.vue